function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#garbage-bin_svg__clip0)",
  fill: "#879097"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.875 13.125c0 1.034.84 1.875 1.875 1.875h7.5a1.877 1.877 0 001.875-1.875V3.75H1.875v9.375zM9.375.937V0h-3.75v.937H.937v1.875h13.126V.937H9.375z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "garbage-bin_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})));

function SvgGarbageBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgGarbageBin;